function toolTipHelpDirective() {
	return {
		scope: {
			classText: '@?',
			title: '@'
		},
		template : function(elem, attr, s) {
			return '<i class="fa fa-question-circle ' + (attr.classText || '') + '" data-toggle="tooltip" title="'+attr.title+'"></i>';
		}
	}
};

module.directive('toolTipHelp', [ toolTipHelpDirective ]);